export class PriceUtils {

  public static prefixDecimalPart(price: string, language: string): string {
    const comma = language === 'en' ? '.' : ',';
    return price ? comma + price : undefined;
  }
}
